export default "__VITE_ASSET__CKwM8T54__"